import { render, staticRenderFns } from "./onsultscript.vue?vue&type=template&id=5b27cf0e&scoped=true"
import script from "./onsultscript.vue?vue&type=script&lang=js"
export * from "./onsultscript.vue?vue&type=script&lang=js"
import style0 from "./onsultscript.vue?vue&type=style&index=0&id=5b27cf0e&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b27cf0e",
  null
  
)

export default component.exports